const initTopicAcciones = () => {
    const contenedor = document.querySelector('.clases-temario-single__data-top');

    if (!contenedor) return;

    const favorito = contenedor.querySelector('#favorite');
    const completado = contenedor.querySelector('#marcar-completado');
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    if (!favorito || !completado) return;
    
    favorito.addEventListener('click', async () => {
        const id_clase = favorito.getAttribute('data-id');
        const user_id = favorito.getAttribute('data-user');
        const restBase = protocol + '//' + hostname + '/wp-json/topic-favorita-rest/v1';

        const data = {
            action: 'user_acciones_rest',
            user_id,
            id_clase
        };

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                data: data,
            }),
        };

        fetch(restBase + '/update', options)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Mostrar mensaje de éxito
                    alert('Clase marcada como favorita correctamente');
                    favorito.classList.toggle('active');
                } else {
                    // Mostrar mensaje de error
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Ocurrió un error al marcar la clase como favorita');
            }); 
    });

    completado.addEventListener('click', async () => {
        const id_clase = completado.getAttribute('data-id');
        const user_id = completado.getAttribute('data-user');
        const tipo = "topic";
        const restBase = protocol + '//' + hostname + '/wp-json/topic-completada-rest/v1';

        const data = {
            action: 'user_acciones_rest',
            user_id,
            id_clase,
            tipo
        };

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                data: data,
            }),
        };

        fetch(restBase + '/update', options)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Mostrar mensaje de éxito
                    alert('Clase marcada como completada correctamente');
                    completado.textContent = 'Completada';
                } else {
                    // Mostrar mensaje de error
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Ocurrió un error al marcar la clase como completada');
            });
    });
};

export default initTopicAcciones;
